<template>
  <div class="skeleton-store">
    <!-- VIP Banner 骨架 -->
    <div class="skeleton-vip-banner"></div>
    
    <!-- Title 骨架 -->
    <div class="skeleton-title"></div>
    
    <!-- 支付渠道骨架 -->
    <div class="skeleton-channels">
      <div v-for="i in 3" :key="i" class="skeleton-channel-item"></div>
    </div>
    
    <!-- Store Item 网格骨架 -->
    <div class="skeleton-items-grid">
      <div v-for="i in 9" :key="i" class="skeleton-store-item h-150px">
        <!-- <div class="skeleton-item-image"></div>
        <div class="skeleton-item-info">
          <div class="skeleton-item-amount"></div>
          <div class="skeleton-item-button"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme'
</script>

<style scoped lang="scss">
@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.skeleton-store {
  padding: 0 20px;
  
  %skeleton-base {
    background: linear-gradient(
      90deg,
      v-bind('theme.colors.backgroundSecondary') 25%,
      rgba(255, 255, 255, 0.05) 50%,
      v-bind('theme.colors.backgroundSecondary') 75%
    );
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
    border-radius: 8px;
  }
  
  .skeleton-vip-banner {
    @extend %skeleton-base;
    height: 40px;
    width: 100%;
    margin-bottom: 10px;
    border-radius: 10px;
  }
  
  .skeleton-title {
    @extend %skeleton-base;
    height: 16px;
    width: 60%;
    margin-bottom: 15px;
  }
  
  .skeleton-channels {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    overflow-x: auto;
    
    .skeleton-channel-item {
      @extend %skeleton-base;
      width: 69px;
      height: 32px;
      flex-shrink: 0;
      border-radius: 10px;
    }
  }
  
  .skeleton-items-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    
    .skeleton-store-item {
      @extend %skeleton-base;
      // background: v-bind('theme.colors.backgroundSecondary');
      border-radius: 10px;
      padding: 10px;
      
      // .skeleton-item-image {
      //   @extend %skeleton-base;
      //   width: 100%;
      //   height: 100px;
      //   margin-bottom: 10px;
      //   border-radius: 8px;
      // }
      
      // .skeleton-item-info {
      //   .skeleton-item-amount {
      //     @extend %skeleton-base;
      //     height: 20px;
      //     width: 70%;
      //     margin: 0 auto 10px;
      //   }
        
      //   .skeleton-item-button {
      //     @extend %skeleton-base;
      //     height: 25px;
      //     width: 100%;
      //     border-radius: 18px;
      //   }
      // }
    }
  }
}
</style>

